<template>
	<div class="row dynvibeRow">
		<div class="col-lg-12">
			<div class="dynvibeBox">
				<div class="col-lg-12">
					<div class="col-lg-12 dynvibeTitleBox">
						<h2>Moodboard</h2>
					</div>
				</div>
				<div v-if="modalHues.length === 0 && modalMedias.length === 0" class="noData"><p>No Data to display</p></div>
				<div v-else>
					<div v-if="modalHues.length > 0" class="row dynvibeRow">
						<div class="col-lg-12" style="margin-bottom: 20px">
							<div class="col-xs-2">
								<label class="control-label">Select a color</label>
								<br />
								<button class="reset-color" @click="resetTableColor('color')">Reset</button>
							</div>
							<div class="col-xs-10">
								<table id="hue-table">
									<tr>
										<td v-for="value in modalHues" :key="value">
											{{ value["doc_count"] }}
										</td>
									</tr>
									<tr>
										<td
											v-for="value in modalHues"
											:style="hueStyle(value)"
											@click="colorClicked(value, 'hue')"
											:key="value"
										></td>
									</tr>
								</table>
								<table id="subhue-table">
									<tr>
										<td
											v-for="subvalue in modalSubHues"
											:style="hueStyle(subvalue)"
											@click="colorClicked(subvalue, 'subhue')"
											:key="subvalue"
										></td>
									</tr>
									<tr>
										<td v-for="subvalue in modalSubHues" :key="subvalue">
											{{ subvalue["doc_count"] }}
										</td>
									</tr>
								</table>
							</div>
						</div>
						<div v-if="modalBrands.length > 0 || modalObjects.length > 0" class="col-lg-12 dynvibeSearch">
							<div class="col-xs-2">
								<label class="control-label">Select a category</label>
								<br />
								<button class="reset-color" @click="resetTableColor('object')">Reset</button>
							</div>
							<div id="dynvibeSearchFiltersBase" class="col-xs-10">
								<div class="col-xs-3">
									<select class="listSort dynvibeListSort" name="brand" data-type="brand" @change="onChangeBrands">
										<option value="">Choose a brand</option>
										<option v-for="brand in modalBrands" :key="brand.key" :value="brand.key">
											{{ brand.key }} ({{ brand.doc_count }})
										</option>
									</select>
									<div
										@click="clickOnArianeBrands(selectedBrand)"
										class="menuArianeBrand menuAriane"
										v-for="selectedBrand in selectedBrands"
										:key="selectedBrand"
									>
										<span class="menuArianeValue">{{ selectedBrand }}</span> <i class="icon-x"></i>
									</div>
								</div>
								<div class="col-xs-3">
									<select class="listSort dynvibeListSort" name="object" data-type="object" @change="onChangeObjects">
										<option value="">Choose an object</option>
										<option v-for="object in modalObjects" :key="object.key" :value="object.key">
											{{ object.key }} ({{ object.doc_count }})
										</option>
									</select>
									<div
										@click="clickOnArianeObjects(selectedObject)"
										class="menuArianeObject menuAriane"
										v-for="selectedObject in selectedObjects"
										:key="selectedObject"
									>
										<span class="menuArianeValue">{{ selectedObject }}</span> <i class="icon-x"></i>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="row dynvibeRow mediasContent">
						<div class="row dynvibeRow">
							<div class="col-lg-12">
								<ul class="dynvibeGalleryMedias">
									<li v-for="media in modalMedias" :key="getMediaId(media)" aria-hidden="false" class="filterMedia">
										<a :href="getMediaUrl(media)" target="_blank" :style="getMediaStyle(media)">
											<span class="dynvibeGalleryMediasFilter"></span>
											<span class="dynvibeGalleryPopularMediasHover">
												<span class="icon-select-image"></span>
												{{ getMediaContent(media) }}
											</span>
										</a>
									</li>
								</ul>
							</div>
						</div>
						<button class="dynvibeShowMore" @click="showMore()">Show More</button>
					</div>
				</div>
			</div>
		</div>
		<div>
			<mediacontent
				ref="mediacontent"
				fromPage="moodboard"
				:filters="filters"
				:moodboardSelectedColor="selectedColor"
				:moodboardSelectedBrands="selectedBrands"
				:moodboardSelectedObjects="selectedObjects"
				:moodboardModalHues="modalHues"
				:moodboardModalSubHues="modalSubHues"
				:moodboardModalBrands="modalBrands"
				:moodboardModalObjects="modalObjects"
			></mediacontent>
		</div>
	</div>
</template>

<script>
//import confirm from "@/components/globalVue/Confirm.vue";
import mediacontent from "@/components/globalVue/MediaContent.vue";

export default {
	name: "moodboard",
	inject: ["picture_host"],
	props: {
		filters: {
			type: Object,
			default: function () {
				return {};
			},
		},
	},
	data() {
		return {
			contentLoading: true,
			modalMedias: [],
			modalHues: [],
			modalSubHues: [],
			modalBrands: [],
			modalObjects: [],
			totalCountHues: 0,
			selectedColor: {},
			selectedBrands: [],
			selectedObjects: [],
			nbPhotos: 24,
			loadingHues: true,
		};
	},
	components: {
		//confirm: confirm,
		mediacontent: mediacontent,
	},
	created() {
		this.loadModal();
	},
	methods: {
		getMediaId(media) {
			return media["tophits"]["hits"]["hits"][0]["_id"];
		},
		getMediaContent(media) {
			return media["tophits"]["hits"]["hits"][0]["_source"]["post_content"];
		},
		getMediaSource(media) {
			return media["tophits"]["hits"]["hits"][0]["_source"]["post_media"];
		},
		getMediaUrl(media) {
			return media["tophits"]["hits"]["hits"][0]["_source"]["post_url"];
		},
		getMediaPicture(media) {
			return media["tophits"]["hits"]["hits"][0]["_source"]["post_url"].replace("https://www.instagram.com/p/", "").replace("/", "");
			//return media['key'];
		},
		getMediaStyle(media) {
			let picture = this.getMediaPicture(media);
			let profile_id = media["tophits"]["hits"]["hits"][0]["_source"]["profile_id"];

			if (media["tophits"]["hits"]["hits"][0]["_source"]["post_media"] === "instagram") {
				picture = this.picture_host + profile_id + "/source/" + picture + ".jpg";
			}

			return (
				"background-image:url(" +
				picture +
				");width: 184px;height: 184px;display: block;background-position: center;background-size: cover;    border: 1px solid #DDD;"
			);
		},
		reloadModalContent(contentLoading = true) {
			this.contentLoading = contentLoading;
			let params = {
				parameters: this.filters,
				data: {
					selectedColor: this.selectedColor,
					selectedBrands: this.selectedBrands,
					selectedObjects: this.selectedObjects,
					nbPhotos: this.nbPhotos,
				},
			};

			this.$axios.post(this.$backendUrl + "mediaContent", this.$Qs.stringify(params)).then((response) => {
				this.modalMedias = Object.values(response.data.results.pictures);
				if (Object.keys(this.selectedColor).length === 0) {
					this.modalHues = Object.values(response.data.results.hue);
				}
				this.totalCountHues = response.data.totalCountHues;

				this.modalBrands = Object.values(response.data.results.brands);
				this.modalObjects = Object.values(response.data.results.objects);
				this.contentLoading = false;
			});
		},
		loadModal() {
			this.nbPhotos = 24;
			this.reloadModalContent();
		},
		hexToRgb(hex) {
			// Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
			const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
			hex = hex.replace(shorthandRegex, function (m, r, g, b) {
				return r + r + g + g + b + b;
			});

			let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
			return result
				? {
						r: parseInt(result[1], 16),
						g: parseInt(result[2], 16),
						b: parseInt(result[3], 16),
				  }
				: null;
		},
		resetTableColor(type) {
			if (type === "color") {
				this.selectedColor = {};
				this.modalSubHues = [];
			} else if (type === "object") {
				this.selectedBrands = [];
				this.selectedObjects = [];
				this.modalBrands = [];
				this.modalObjects = [];
			}
			this.loadModal();
		},
		getTableColor(colorName, type) {
			this.selectedColor = {
				type: type,
				color: colorName,
			};
			this.loadModal();
		},
		hueStyle(value) {
			let color = value["key"];
			return "background-color:" + color;
		},
		colorClicked(value, type) {
			this.getTableColor(value["key"], type);
			if (type === "hue") {
				this.modalSubHues = value["name"]["buckets"];
			}
		},
		clickOnArianeObjects(selectedObject) {
			this.selectedObjects.splice(this.selectedObjects.indexOf(selectedObject), 1);
			this.modalObjects = [];
		},
		clickOnArianeBrands(selectedBrand) {
			this.selectedBrands.splice(this.selectedBrands.indexOf(selectedBrand), 1);
			this.modalBrands = [];
		},
		showMore() {
			this.$refs.mediacontent.loadModal();
		},
		onChangeBrands(e) {
			if (e.target.value !== "" && !this.selectedBrands.includes(e.target.value)) {
				this.selectedBrands.push(e.target.value);
			}
		},
		onChangeObjects(e) {
			if (e.target.value !== "" && !this.selectedObjects.includes(e.target.value)) {
				this.selectedObjects.push(e.target.value);
			}
		},
	},
	watch: {
		selectedBrands: {
			handler() {
				this.loadModal();
			},
			deep: true,
		},
		selectedObjects: {
			handler() {
				this.loadModal();
			},
			deep: true,
		},
		filters: {
			handler() {
				this.modalHues = [];
				this.resetTableColor("color");
				this.resetTableColor("object");
				this.reloadModalContent();
			},
			deep: true,
			immediate: true,
		},
	},
};
</script>

<style scoped>
.modal-body {
	min-height: 73vh;
}

.modal-mask {
	position: fixed;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
}

.modal-wrapper {
	display: table-cell;
	vertical-align: middle;
}

.close {
	outline: 0;
}

.dynvibeBox {
	min-height: 170px;
}

.dynvibeTitleModal {
	padding-bottom: 10px;
	margin-bottom: 0;
}

.dynvibeInputRadio input:checked {
	border-color: #33d1cd;
}

.dynvibeGalleryMedias {
	list-style: none;
}

.dynvibeGalleryMedias > li {
	display: inline-block;
}

.filterMedia {
	margin: 5px;
}

.dynvibeGalleryMediasFilter {
	position: absolute;
	top: 4px;
	width: 176px;
	height: 176px;
	display: none;
	background-color: rgba(35, 5, 107, 0.5);
}

.dynvibeGalleryMedias a:hover .dynvibeGalleryMediasFilter,
.imageSlider:hover .dynvibeGalleryMediasFilter {
	display: block;
}

.dynvibeGalleryMedias a:hover .dynvibeGalleryMediasHover,
.imageSlider:hover .dynvibeGalleryMediasHover {
	display: block;
}

.dynvibeGalleryMedias a:hover .dynvibeGalleryPopularMediasHover,
.imageSlider:hover .dynvibeGalleryPopularMediasHover {
	display: block;
}

.dynvibeGalleryMedias a {
	border: 4px solid white;
}

.dynvibeGalleryMedias a.selected-image {
	border: 4px solid #6ef132;
}

.dynvibeGalleryPopularMediasHover {
	display: none;
	position: absolute;
	top: 5%;
	width: 97%;
	text-align: center;
	text-transform: initial;
	color: #33d1cd;
	font-weight: 700;
	font-size: 12px;
	max-height: 93%;
	overflow: hidden;
}

.dynvibeGalleryPopularMediasHover button {
	display: none;
	font-weight: 700;
}

.dynvibeGalleryPopularMediasHover button.btn-display {
	display: block;
}

.filterMedia {
	float: left;
	list-style: none;
	position: relative;
	width: 176px;
	margin-right: 15px;
	margin-bottom: 10px;
}
</style>
<style scoped>
.dynvibeModalPostsActionsAdd {
	display: block;
}

#hue-table,
#subhue-table {
	width: 100%;
	height: 55px;
}

#hue-table {
	margin-bottom: 10px;
}

#hue-table td,
#subhue-table td {
	cursor: pointer;
	text-align: center;
	font-weight: bold;
	border-right: 10px solid #fff;
}

#hue-table td:hover,
#subhue-table td:hover {
	opacity: 0.8;
}

#hue-table tr:first-child {
	height: 20px;
}

#subhue-table tr:last-child {
	height: 20px;
}

.reset-color {
	color: red;
	border: 1px solid red;
	background-color: transparent;
	margin-top: 5px;
}

.dynvibeSearch {
	border: none;
}

.dynvibeSearch #dynvibeSearchFiltersBase select {
	width: 100%;
}

.dynvibeModalPostsActionsFooterBtn {
	width: 100%;
	display: block;
}

.dynvibeModalPostsActions {
	border: none;
	text-align: left;
	padding: 0px;
}

.menuAriane {
	display: flex;
	align-items: center;
	height: 20px;
	min-width: 150px;
	padding: 0px 4px 0px 7px;
	margin-right: 10px;
	border-radius: 12px;
	margin: 0;
	font-size: 13px;
	font-weight: 700;
	text-transform: uppercase;
	cursor: pointer;
}

.menuArianeAdd {
	display: inline-block;
	color: #33d1cd;
	border: 1px solid #33d1cd;
}

.menuAriane i {
	font-size: 6px;
	padding: 4px;
	margin-left: auto;
	border-radius: 50%;
}

.menuArianeValue {
	margin-right: 20px;
}

.menuArianeBrand {
	color: #ef402e;
	border: 1px solid #ef402e;
	margin-bottom: 5px;
}

.menuArianeBrand i {
	color: #fff;
	background-color: #ef402e;
}

.menuArianeObject {
	color: #33d1cd;
	border: 1px solid #33d1cd;
	margin-bottom: 5px;
}

.menuArianeObject i {
	color: #fff;
	background-color: #33d1cd;
}

.menuMastertagToAdd i {
	color: #fff;
	background-color: #33d1cd;
}

.mastertag-selected {
	background-color: #e30f0f;
	color: #fff;
}
.dynvibeShowMore {
	margin: auto;
	display: block;
}
</style>
